<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Stripe Users</h2>
        <div class="d-flex flex-wrap justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="openSearch">Search</a>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <div class="items-per-page-dropdown mb-3">
            <label>Items Per Page: </label>
            <select v-model="size" @change="updateItemsPerPage">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('stripeUserId')">Stripe User Id</th>
              <th class="col-1" @click="toggleSort('stripeConfigurationId')">Stripe Configuration Id</th>
              <th class="col-1" @click="toggleSort('userId')">User Id</th>
              <th class="col-1" @click="toggleSort('stripeCustomerId')">Stripe Customer Id</th>
              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.stripeUserId">
              <td class="col-1 text-truncate" v-html="truncateText(config.stripeUserId, 10)"  @click="selectText" :data-text="config.stripeUserId" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.stripeConfigurationId, 10)"  @click="selectText" :data-text="config.stripeConfigurationId" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.userId, 50)" @click="selectText" :data-text="config.userId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.stripeCustomerId, 30)" @click="selectText" :data-text="config.stripeCustomerId"></td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'StripeUserEdit', params: { stripeUserId: config.stripeUserId, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <br>
        <vue-awesome-paginate
            :total-items="totalElements"
            :items-per-page="size"
            :max-pages-shown="5"
            v-model="page"
            :on-click="changePage"
        />
      </div>
    </div>
    <!-- Modal -->
    <div class="modal d-block" v-if="showSearch">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title fw-bold">Search in stripe users</h4>
            <button role="button" class="close close-modal" data-dismiss="modal" aria-label="Close" @click="closeSearch">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="modal-form">
              <label>Stripe user id</label>
              <input type="text" v-model="searchFilters.stripeUserId">
              <label >Stripe configuration id</label>
              <input type="text" v-model="searchFilters.stripeConfigurationId">
              <label>User id</label>
              <input type="text" v-model="searchFilters.userId">
              <label>User Email</label>
              <input type="text" v-model="searchFilters.email">
              <label >Stripe customer id</label>
              <input type="text" v-model="searchFilters.stripeCustomerId">
            </form>
            <div v-if="errorMessage !== ''" class="error-message">{{errorMessage}}</div>
          </div>
          <div class="modal-footer">
            <a class="btn cancel-btn" role="button" data-dismiss="modal" @click="closeSearch">Cancel</a>
            <a class="btn signout-popup text-white" role="button" @click="doLoadData">Search</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import {Sort, StripeUserFilter, StripeUserRequest} from "@/model/models";

export default {
  name: "StripeUsers",
  components: {
    Header,
  },
  data() {
    return {
      showSearch: false,
      page: 1,
      size: 20,
      totalElements: 0,
      stripeUserList: [],
      sortColumn: null,
      sortDirection: "ASC",
      errorMessage: null,
      searchFilters: new StripeUserFilter(null,null,null,null,null),
    };
  },
  computed: {
    sortData() {
      return this.stripeUserList;
    },
  },
  created() {
    this.doLoadData();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));
  },
  methods: {
    changePage(page) {
      this.page = page
      this.doLoadData()
    },
    doLoadData() {
      let request = new StripeUserRequest(
          this.page - 1,
          this.size
      );
      if (this.sortColumn != null) {
        request.sort = new Sort(this.sortColumn, this.sortDirection);
      }
      request.filter = new StripeUserFilter(
          this.searchFilters.stripeUserId, this.searchFilters.stripeConfigurationId, this.searchFilters.userId, this.searchFilters.email,  this.searchFilters.stripeCustomerId
      );

      AdminService.getStripeUserList(request).then((data) => {
        this.showSearch = false
        this.stripeUserList = data.stripeUserList;
        this.page = data.page + 1
        this.totalElements = data.totalElements
        this.searchFilters = new StripeUserFilter(
            data.filter.stripeUserId, data.filter.stripeConfigurationId, data.filter.userId, data.filter.email,  data.filter.stripeCustomerId
        );
      }).catch((error) => {
        if (error.response) {
          this.errorMessage = error.response.data.message;
        }
        console.log(error)
      });
    },
    openSearch() {
      this.searchFilters = new StripeUserFilter(null,null,null,null, null)
      this.page = 1
      this.showSearch = true
    },
    closeSearch() {
      this.searchFilters = new StripeUserFilter(null,null,null,null, null)
      this.showSearch = false
      this.errorMessage = null
    },
    redirectToCreate() {
      this.$router.push({ name: 'StripeUserCreate' });
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },
    truncateText(text, limit) {
      if (text === undefined) {
        return null
      } else {
        return text.length > limit ? text.substring(0, limit) + '...' : text;
      }
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      await navigator.clipboard.writeText(originalText);
      this.highlightElement(event.target);
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'ASC';
      }
      this.doLoadData()
    },
    updateItemsPerPage() {
      this.doLoadData()
    },
    applyFilter(column) {
      // Implement filtering based on the search criteria for the selected column
      const filterValue = this.searchFilters[column].toLowerCase();

      const filteredData = this.dataRows.filter(row => {
        return row[column].toLowerCase().includes(filterValue);
      });

      // Update the dataRows with the filtered data
      this.dataRows = filteredData;
    },
  },
  mounted() {
    window.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && this.showSearch) {
        this.closeSearch();
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('keyup', this.closeSearch);
  }
};
</script>
<style src="../../assets/style.css">
</style>
